import { fetchFromObject } from '@/utils/helpers/object';

export default {
  getters: () => ({
    getByField: field => fetchFromObject(useStore(), field)
  })
};
